export type OrderParams = {
  minOrderTotalAmount: number;
  maxOrderTotalAmount: number;
};

export type ProductDetails = {
  productId: string;
  type: ProductType;
  channel: ProductChannel;
  campaignId?: string;
};

export type ProductParams = {
  minLoanAmount: number;
  maxLoanAmount: number;
  minDownPaymentPercent: number;
  maxDownPaymentPercent: number;
  termsInMonths: number[];
  // amount of interest per month
  minMonthlyInterestRate: number;
  maxMonthlyInterestRate: number;
  // fixed processing fee
  minOriginationFeeFlat: number;
  maxOriginationFeeFlat: number;
  // processing fee per month
  minOriginationFeeRate: number;
  maxOriginationFeeRate: number;
};

export type Product = ProductParams & OrderParams & ProductDetails;

export function isProduct(
  maybeProduct?: Product | OrderParams
): maybeProduct is Product {
  return typeof maybeProduct !== 'undefined' && 'productId' in maybeProduct;
}

export type ProductType = 'LOAN' | 'LOAN_ZERO_RATE';
export type ProductChannel = 'OFFLINE' | 'ONLINE';
